import { Suspense, lazy, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';
import { Feature, useFeatures } from '@/contexts/FeaturesContext';
import { SatAiGenerateResponse } from '@/api/sat';

const SatAiGenerateDrawer = lazy(() => import('@/components/SatAiGenerateDrawer').then((m) => ({ default: m.SatAiGenerateDrawer })));

export function SatAiFloatingButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isEnabled } = useFeatures();
  const aiEnabled = isEnabled(Feature.AI_QUESTION_GENERATION.name);
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Only show on /sat routes
  const isOnSatRoute = location.pathname.startsWith('/sat');

  if (!aiEnabled || !isOnSatRoute) return null;

  const handleGenerated = (result: SatAiGenerateResponse) => {
    navigate('/sat/questions/editor/new', { 
      state: { aiGenerated: result } 
    });
  };

  return (
    <>
      <Button
        onClick={() => setDrawerOpen(true)}
        variant="outline"
        size="icon"
        className="fixed bottom-24 right-6 h-14 w-14 rounded-full shadow-lg z-40 transition-all duration-300 hover:scale-110 bg-amber-50 dark:bg-amber-950/50 backdrop-blur-sm hover:bg-amber-100 dark:hover:bg-amber-900/50 border-amber-200 dark:border-amber-800"
        title="AI Question Generator"
      >
        <Sparkles className="h-6 w-6 text-amber-500" />
      </Button>

      <Suspense fallback={null}>
        {drawerOpen ? (
          <SatAiGenerateDrawer
            open={drawerOpen}
            onOpenChange={setDrawerOpen}
            onGenerated={handleGenerated}
          />
        ) : null}
      </Suspense>
    </>
  );
}
